import { PageHeader } from "@/components/page-header";
import { useT } from "@/lib/i18n";

/**
 * Client wrapper around `PageHeader` so the `/skills` RSC can render i18n
 * labels without forcing the whole page client-side.
 */
export function SkillsPageHeader() {
  const t = useT();
  return (
    <PageHeader
      eyebrow={t("common.eyebrow.workspace")}
      title={t("skills.title")}
      subtitle={t("skills.subtitle")}
    />
  );
}
